module.exports = __webpack_public_path__ + "static/flow-logo-73e15d61c879f4b442d38f95f42a803a.png";